// extracted by mini-css-extract-plugin
module.exports = {"body":"ThankYouPage_body__1_esg"};